// ----------------------------------------------------------------------------
// Component: Testimonial
// ----------------------------------------------------------------------------
//
// A list of testimonials
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_testimonial.scss';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--testimonials';
const CAROUSEL_CLASS = 'carousel--testimonials';
const CAROUSEL_SECTION_SELECTOR = '.carousel-section--testimonials';
const CAROUSEL_SECTION_CLASS = 'carousel-section--testimonials';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
const CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// -------------------------------------
// Hooks
// -------------------------------------
function handleTestimonialSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        slide.addEventListener('focus', function() {
            var slidePos = swiperEl.$el[0].getBoundingClientRect();

            // Remove standard scrolling to element in focus due to it going off the screen (slides left when it needs to stay on screen)
            swiperEl.$el[0].scrollLeft = 0;
            swiperEl.slideTo(index);

            // Emulating normal tab focus due to needing to remove standard scroll
            // If element is already in viewport, do nothing
            // Otherwise, scroll to the element and it should be in the middle of the screen when scrolling stops
            if (!(slidePos.top >=0 &&
            slidePos.left >=0 &&
            slidePos.bottom <= window.innerHeight &&
            slidePos.right <= window.innerWidth)) {
                window.scrollTo({
                    top: (slidePos.top + window.scrollY) - (window.innerHeight / 2),
                    left: 0,
                    behavior: 'smooth'
                });
            }
        });
    });
}

document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
    .forEach((element, index) => {

        // Generate unique class for each collection list slider
        element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

        // Generate unique btn classes for slider arrows
        element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
        element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

        // Generate unique btn classes for swiper pagination
        element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-pagination-${index}`);

        const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
            slidesPerView: 1,
            spaceBetween: 15,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true,

            navigation: {
                nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
            },

            pagination: {
                el: `.${CAROUSEL_SECTION_CLASS}-pagination-${index}`,
                type: 'bullets',
                clickable: true,
            },
        });

        if (swiper.slides) {
            handleTestimonialSlides(swiper);
        } else {
            swiper.forEach(function(swiperEl) {
                handleTestimonialSlides(swiperEl);
            });
        }
    });
